import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_47o708b9ht: FaireBrandEntity = {
  token: "b_47o708b9ht",
  type: "brand",
  name: "THATCH",
  avatarUrl:
    "https://cdn.faire.com/fastly/98289a6ce275d2faee6fc7e49280eb88a14f031403f2ca62eb8027cc22e040b9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c33b27da5a36549f47adaeb12e025ec20abfaddb1e5f5827a1a0493f0e6fea9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/98289a6ce275d2faee6fc7e49280eb88a14f031403f2ca62eb8027cc22e040b9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c33b27da5a36549f47adaeb12e025ec20abfaddb1e5f5827a1a0493f0e6fea9.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 1000,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Founded in 2014, THATCH was born with the goal of creating jewelry that combines both a luxury and fine essence at an accessible price point. As a brand, we are redefining modern, feminine style - and as a business, we are redefining what and how success is created. The all female team designs unique pieces to create a lineup of forward yet simplistic boutique jewelry. THATCH uses a variety of materials, including sterling silver and repurposed brass that is coated in high grade 14k gold plating. The philosophy of the collection is to make a quality, design forward jewelry collection which is more accessible to women. We like to think of ourselves as attainable luxury for the everyday girl.\n\nThe brand launched with the signature diamond star constellation collection and has since grown to encompass a strong assortment of necklaces, bracelets, earrings and rings.  Our heart & pendants with meaning collections make up some of the top sellers, with a strong point of view, these collections make incredible gifts. The small team of five women handle all aspects of the business in-house, from design, production, sales and marketing. \n\nThe THATCH collection is inspired by modern lines, art & the stars in the night sky. Every piece is made with love to be loved. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:58.152Z",
    importedBy: "entity-db-cli",
  },
};
